<app-header></app-header>

<bit-container>
  <div class="bv-account-page">
    <app-profile></app-profile>

    <app-danger-zone>
      <ng-container>
        <button
          *ngIf="verifyNewDeviceLogin"
          type="button"
          class="bv-account-danger-btn"
          (click)="setNewDeviceLoginProtection()"
        >
          {{ "turnOffNewDeviceLoginProtection" | i18n }}
        </button>
        <button
          *ngIf="!verifyNewDeviceLogin"
          type="button"
          class="bv-account-danger-btn"
          (click)="setNewDeviceLoginProtection()"
        >
          {{ "turnOnNewDeviceLoginProtection" | i18n }}
        </button>
      </ng-container>
      <button type="button" class="bv-account-danger-btn" (click)="deauthorizeSessions()">
        {{ "deauthorizeSessions" | i18n }}
      </button>
      <button
        *ngIf="showPurgeVault$ | async"
        type="button"
        class="bv-account-danger-btn"
        (click)="purgeVault()"
      >
        {{ "purgeVault" | i18n }}
      </button>
      <button
        *ngIf="showDeleteAccount$ | async"
        type="button"
        class="bv-account-danger-btn"
        (click)="deleteAccount()"
      >
        {{ "deleteAccount" | i18n }}
      </button>
    </app-danger-zone>
  </div>
</bit-container>
